import { Auditable } from '../shared/auditable.model';
import { UserModel } from './user.model';
import { AccountModel } from './account.model';
import { VendorModel } from './vendor.model';
import { FileModel } from '../shared/file.model';
import { AssetModel } from './asset.model';
import { AssetMaintenanceScheduleModel } from './asset-maintenance-schedule.model';

export class AssetMaintenanceRecordModel extends Auditable {
  id: number;
  title: string = '';
  description: string;

  asset_id: number;
  asset_maintenance_schedule_id: number;
  vendor_id: number;
  contractor_account_id: number;

  type: string = 'preventive';
  type_other: string;
  status: string = 'open';
  priority: string = 'medium';

  trigger_type: string = 'manual';
  due_at: number;
  started_at: number;
  started_by_user: UserModel;
  completed_at: number;
  completed_by_user: UserModel;
  cancelled_at: number;
  cancelled_by_user: UserModel;

  time_spent_value: number;
  time_spent_unit: string = 'hours';
  account_currency_code: string;
  total_cost: number;
  completion_summary: string;
  cancellation_details: string;

  notes: string;

  created_by_user: UserModel;
  updated_by_user: UserModel;

  asset: AssetModel;
  maintenance_schedule: AssetMaintenanceScheduleModel;
  contractor: AccountModel;
  vendor: VendorModel;

  users: UserModel[] = [];
  files: FileModel[] = [];

  user_ids: number[] = [];
}
